import "./ProcessAnalyticalTechnology.module.css";
import Header from "@/reusable_sections/Header";
import ProcessAnalytics from "./sections/ProcessAnalytics";
import Bottlenecks from "./sections/Bottlenecks";
import Workflow from "./sections/Workflow";
import TechnologyShowcase from "./sections/TechnologyShowcase";
import Applications from "./sections/Applications";
import Milestones from "./sections/Milestones";
import QualificationProtocols from "./sections/QualificationProtocols";
import RelatedLinks from "./sections/RelatedLinks";
import ConsultationBanner from "./sections/ConsultationBanner";
import SolutionHubs from "./sections/SolutionHubs";
import Resources from "./sections/Resources";
import Footer from "@/reusable_sections/Footer";
export default function ProcessAnalyticalTechnologyPage() {
  return <div>
      <Header />
      <ProcessAnalytics />
      <Bottlenecks />
      <Workflow />
      <TechnologyShowcase />
      <Applications />
      <Milestones />
      <QualificationProtocols />
      <RelatedLinks />
      <SolutionHubs />
      <Resources />
      <ConsultationBanner />
      <Footer />
    </div>;
}